/**
 * Input base (design-system §7 · Input): fondo superficie, borde `--fm-border`, radio md,
 * altura 40 px (Admin), foco con borde coral de 2 px y anillo visible.
 */
import { cn } from '../../lib/cn';

import type { InputHTMLAttributes, Ref, TextareaHTMLAttributes } from 'react';

const CONTROL_CLASSES =
  'w-full rounded-fm-md border border-fm-border bg-fm-surface px-fm-3 text-fm-sm text-fm-text ' +
  'placeholder:text-fm-text-disabled transition-colors duration-fm-fast ease-fm-standard ' +
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fm-focus ' +
  'aria-[invalid=true]:border-fm-danger disabled:opacity-45 disabled:cursor-not-allowed ' +
  'motion-reduce:transition-none';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
}

export function Input({ className, invalid, ...props }: InputProps) {
  return (
    <input
      className={cn(CONTROL_CLASSES, 'h-fm-control-sm', className)}
      aria-invalid={invalid ? true : undefined}
      {...props}
    />
  );
}

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  ref?: Ref<HTMLTextAreaElement>;
}

export function Textarea({ className, invalid, rows = 3, ...props }: TextareaProps) {
  return (
    <textarea
      rows={rows}
      className={cn(CONTROL_CLASSES, 'py-fm-2', className)}
      aria-invalid={invalid ? true : undefined}
      {...props}
    />
  );
}
